/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import { PriceAdjustmentType } from '@upstart/harmony/lib/legos/penTypes';
import { isNumber } from 'lodash';

function MarkupDiscount({
  label,
  submitted,
  readOnly,
  value,
  setValue,
  priceAdjustmentType,
  max,
}: {
  label: string;
  submitted: boolean;
  readOnly: boolean;
  value: number | undefined;
  setValue: (val: number | undefined) => {};
  priceAdjustmentType: PriceAdjustmentType;
  max?: number;
}) {
  const minValueValidation = (val: number | undefined) => {
    if (!submitted || val === undefined || val >= 0) {
      return 'success';
    }
    return 'error';
  };
  const info =
    priceAdjustmentType === PriceAdjustmentType.PERCENT
      ? 'Percentage of Price'
      : '$ Dollar Amount';
  const useMax =
    isNumber(max) && priceAdjustmentType === PriceAdjustmentType.PERCENT;

  useEffect(() => {
    if (value && max && useMax && value > max) {
      setValue(max);
    }
  }, [priceAdjustmentType]);

  return (
    <FormGroup
      controlId="markupDiscount"
      validationState={minValueValidation(value)}
    >
      <ControlLabel>{label}</ControlLabel>
      <FormControl
        min="0"
        step=".01"
        type="number"
        className="form-control"
        name={label}
        value={value}
        onChange={e => {
          // @ts-ignore
          if (useMax && e.target.value > max) {
            setValue(max);
          } else {
            // @ts-ignore
            setValue(e.target.value);
          }
        }}
        readOnly={readOnly}
        {...(useMax ? { max } : {})}
      />
      <div className="info">{info}</div>
      <FormControl.Feedback type="error">
        <div className="p-form-field-message">Minimum Value is 0</div>
      </FormControl.Feedback>
    </FormGroup>
  );
}

export default MarkupDiscount;
